import { ButtonProps, CircularProgress, Button as BaseButton } from "@mui/material";

type Props = {
    loading?: boolean;
};

const Button = ({loading=false, children, ...props}: ButtonProps & Props) => {
    return (
        <BaseButton {...props}>
            {loading && <CircularProgress size={10} />}
            {children}
        </BaseButton>
    );
};

export { Button };